import { useTranslation } from "react-i18next";
import PolicyPageLayout, {
  PolicySection,
} from "../shared/components/PolicyPageLayout";

const CopyrightPolicy = () => {
  const { t } = useTranslation("home");

  return (
    <PolicyPageLayout title={t("copyrightPolicy.title")}>
      <PolicySection>{t("copyrightPolicy.content")}</PolicySection>
    </PolicyPageLayout>
  );
};

export default CopyrightPolicy;
